var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceLockedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-NG-1---Ice-Locked",
    transform: "translate(-237 -74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(237 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#D70022"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22,
    cy: 22,
    r: 22
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 31.25c0 1.24-1.01 2.25-2.25 2.25h-13.5c-1.24 0-2.25-1.01-2.25-2.25v-10.5c0-1.24 1.01-2.25 2.25-2.25h13.5c1.24 0 2.25 1.01 2.25 2.25v10.5zm-15-18a3.755 3.755 0 013.75-3.75h4.5a3.755 3.755 0 013.75 3.75V17h-12v-3.75zM30 17.076V13.25A5.256 5.256 0 0024.75 8h-4.5A5.256 5.256 0 0015 13.25v3.826c-1.71.348-3 1.863-3 3.674v10.5A3.755 3.755 0 0015.75 35h13.5A3.755 3.755 0 0033 31.25v-10.5c0-1.81-1.29-3.326-3-3.674z",
    id: "padlock",
    fill: "#FFF"
  }))))));
}
SvgIceLockedIcon.displayName = 'IceLockedIcon';
export default SvgIceLockedIcon;